export const getLoading = state => state.loading;
export const getUserInfo = state => state.userInfo;
export const getAgentList = state => state.agentList;
export const getAgentInfo = state => state.agentInfo;
export const getStoreList = state => state.storeList;
export const getECUStoreList = state => state.ecuStoreList;



// WEBPACK FOOTER //
// ./src/store/getters.js